import { Spinner } from '@/components/ui/Spinner';

export const LoadingOverlay = () => (
  <div className="flex h-full w-full items-center justify-center">
    <Spinner size="lg" variant="default" />
  </div>
);

export default LoadingOverlay;
